import { useState } from "react";
import { embedUrl, parseVideo } from "../../lib/video.js";
import { track } from "../../lib/analytics.js";

/** Click-to-load facade: no third-party iframe until the visitor presses play. */
export default function VideoEmbed({ video, title, poster }) {
  const [playing, setPlaying] = useState(false);
  const parsed = parseVideo(video);
  if (!parsed) return null;
  if (playing) {
    return (
      <div className="video-embed video-embed--playing">
        <iframe
          src={embedUrl(parsed)}
          title={title}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="video-embed"
      data-provider={parsed.provider}
      data-id={parsed.id}
      data-title={title}
      style={poster ? { backgroundImage: `url(${poster}-960.webp)` } : undefined}
    >
      <button
        type="button"
        className="video-embed__play"
        aria-label={`Play video: ${title}`}
        onClick={() => {
          setPlaying(true);
          track("video_play", { video_title: title });
        }}
      >
        <span className="video-embed__icon" aria-hidden="true" />
        <span className="video-embed__title">{title}</span>
      </button>
    </div>
  );
}
